import { SECTION_REGISTRY, type SectionData } from "./sections/registry";

function SectionWrapper({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div>
      <h2 className="text-lg font-semibold text-foreground mb-3">{title}</h2>
      <div>{children}</div>
    </div>
  );
}

export function SectionRenderer({ sections }: { sections: SectionData[] }) {
  if (!sections || !Array.isArray(sections)) return null;

  return (
    <div className="space-y-10">
      {sections.map((section, i) => {
        const Component = SECTION_REGISTRY[section.type];
        if (!Component) {
          return (
            <div key={i} className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-4">
              <p className="text-sm text-amber-500">
                Unknown section type: <code className="font-mono">{section.type}</code>
              </p>
            </div>
          );
        }
        return (
          <SectionWrapper key={i} title={section.title}>
            <Component data={section.data} />
          </SectionWrapper>
        );
      })}
    </div>
  );
}
